export const CATEGORY_CODES = {
  SVID_PRAVO_NASLED: "SVID_PRAVO_NASLED",
  STATEMENT: "SVID_PODLINNOST_PODPISI",
  ZAVESCHANIE: "ZAVESCHANIE",
  APPLICATIONS: "APPLICATIONS",
  SOVER_EXECUT_NADPIS: "SOVER_EXECUT_NADPIS",
};
